import Link from 'next/link'

import { User } from '~/api-definition/definition'
import { AppImage } from '~/components/data-display/AppImage'
import { userAttributesLabel, userProfileIconOpt } from '~/libs/user'

export const IntroductionLetterUserInfo: React.FC<{ user: User }> = (props) => {
  return (
    <div className="text-sm">
      <div className="flex gap-1">
        <Link
          href={`/foodies/${props.user.userName}`}
          className="flex-shrink-0"
        >
          <AppImage
            src={userProfileIconOpt(props.user)}
            variant={{ type: 'profile', user: props.user }}
            alt={`${props.user.displayName}さんのプロフィール画像`}
            rounded="full"
            width={30}
            height={30}
          />
        </Link>
        <div className="min-w-0">
          <div className="flex gap-1 ml-2">
            <span className="font-bold truncate">{props.user.displayName}</span>
            <span className="text-[13px] text-[#6c6c6c] truncate">
              @{props.user.userName}
            </span>
          </div>
          <span className="text-xs">{userAttributesLabel(props.user)}</span>
        </div>
      </div>
    </div>
  )
}
